<p-multiSelect
  [options]="items"
  [(ngModel)]="selectedItems"
  placeholder="Izaberite magacine"
  (onChange)="selectedItemsOnChange()"
  [id]="formCtrlId"
  [disabled]="disabled"
></p-multiSelect>
